/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import Accesspage from "./../../common/404";
import Add_User from "./../../modules/settings/User/Add-User";
import Add_Role from "./../../modules/settings/Role/Add-Role";
import User_List from "./../../modules/settings/User/User-List";
import User_Details from "./../../modules/settings/User/User-Details";
class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      showAdd: false,
      showEdit: false,
      showView: false,
    };
  }
  componentDidMount() {
    // this.renderPermission();
  }
  renderbodyLayer() {
    const { id, slug } = this.props.match.params;
    const { menuList } = this.props;
    let showAdd = false;
    let showEdit = false;
    let showView = false;
    menuList.map((menu) => {
      if (slug !== undefined && slug !== null && slug !== "") {
        if (menu["route"] === id) {
          menu["submenu"].map((smenu) => {
            if (
              slug === "addtvscreen" ||
              slug === "edittvscreen" ||
              slug === "viewtvscreen"
            ) {
              menu["submenu"].map((srmenu) => {
                if (srmenu["route"] === "tv-screens") {
                  showView = JSON.parse(srmenu["permissions"]["view"]);
                  showAdd = JSON.parse(srmenu["permissions"]["add"]);
                  showEdit = JSON.parse(srmenu["permissions"]["edit"]);
                }
              });
            }

            if (
              slug === "add-user" ||
              slug === "edit-user" ||
              slug === "view-user"
            ) {
              menu["submenu"].map((srmenu) => {
                if (srmenu["route"] === "users") {
                  showView = JSON.parse(srmenu["permissions"]["view"]);
                  showAdd = JSON.parse(srmenu["permissions"]["add"]);
                  showEdit = JSON.parse(srmenu["permissions"]["edit"]);
                }
              });
            }

            if (
              slug === "add-doctor" ||
              slug === "edit-doctor" ||
              slug === "view-doctor"
            ) {
              menu["submenu"].map((srmenu) => {
                if (srmenu["route"] === "doctors") {
                  showView = JSON.parse(srmenu["permissions"]["view"]);
                  showAdd = JSON.parse(srmenu["permissions"]["add"]);
                  showEdit = JSON.parse(srmenu["permissions"]["edit"]);
                }
              });
            }
            if (
              slug === "add-role" ||
              slug === "edit-role" ||
              slug === "view-role"
            ) {
              menu["submenu"].map((srmenu) => {
                if (srmenu["route"] === "roles") {
                  showView = JSON.parse(srmenu["permissions"]["view"]);
                  showAdd = JSON.parse(srmenu["permissions"]["add"]);
                  showEdit = JSON.parse(srmenu["permissions"]["edit"]);
                }
              });
            }
            if (
              slug === "add-service-group" ||
              slug === "edit-service-group" ||
              slug === "view-service-group"
            ) {
              menu["submenu"].map((srmenu) => {
                if (srmenu["route"] === "service-group") {
                  showView = JSON.parse(srmenu["permissions"]["view"]);
                  showAdd = JSON.parse(srmenu["permissions"]["add"]);
                  showEdit = JSON.parse(srmenu["permissions"]["edit"]);
                }
              });
            }
            if (
              slug === "add-work-stations" ||
              slug === "edit-work-stations" ||
              slug === "view-work-stations"
            ) {
              menu["submenu"].map((srmenu) => {
                if (srmenu["route"] === "work-stations") {
                  showView = JSON.parse(srmenu["permissions"]["view"]);
                  showAdd = JSON.parse(srmenu["permissions"]["add"]);
                  showEdit = JSON.parse(srmenu["permissions"]["edit"]);
                }
              });
            }
            if (
              slug === "add-departments" ||
              slug === "edit-departments" ||
              slug === "view-departments"
            ) {
              menu["submenu"].map((srmenu) => {
                if (srmenu["route"] === "departments") {
                  showView = JSON.parse(srmenu["permissions"]["view"]);
                  showAdd = JSON.parse(srmenu["permissions"]["add"]);
                  showEdit = JSON.parse(srmenu["permissions"]["edit"]);
                }
              });
            }
            if (
              slug === "add-services" ||
              slug === "edit-services" ||
              slug === "view-services"
            ) {
              menu["submenu"].map((srmenu) => {
                if (srmenu["route"] === "services") {
                  showView = JSON.parse(srmenu["permissions"]["view"]);
                  showAdd = JSON.parse(srmenu["permissions"]["add"]);
                  showEdit = JSON.parse(srmenu["permissions"]["edit"]);
                }
              });
            }
            if (
              slug === "add-units" ||
              slug === "edit-units" ||
              slug === "view-units"
            ) {
              menu["submenu"].map((srmenu) => {
                if (srmenu["route"] === "units") {
                  showView = JSON.parse(srmenu["permissions"]["view"]);
                  showAdd = JSON.parse(srmenu["permissions"]["add"]);
                  showEdit = JSON.parse(srmenu["permissions"]["edit"]);
                }
              });
            }
            if (smenu["route"] === slug) {
              showView = JSON.parse(smenu["permissions"]["view"]);
              showAdd = JSON.parse(smenu["permissions"]["add"]);
              showEdit = JSON.parse(smenu["permissions"]["edit"]);
            }
          });
        }
      }

      if (slug === undefined && id !== undefined) {
        if (menu["route"] === id) {
          showView = JSON.parse(menu["permissions"]["view"]);
          showAdd = JSON.parse(menu["permissions"]["add"]);
          showEdit = JSON.parse(menu["permissions"]["edit"]);
        }
      }
    });

    var page = null;
    // if (obj !== undefined) {
    switch (slug) {
      case "users":
      case "doctors":
      case "roles":
      case "service-group":
      case "units":
      case "work-stations":
      case "departments":
      case "services":
      case "tv-screens":
        if (showView) {
          page = <User_List {...this.props} menuList={menuList} />;
        } else {
          page = <Accesspage></Accesspage>;
        }
        break;
      case "add-user":
      case "add-doctor":
      case "addtvscreen":
      case "add-service-group":
      case "add-units":
      case "add-work-stations":
      case "add-departments":
      case "add-services":
        if (showAdd) {
          page = <Add_User {...this.props} menuList={menuList} />;
        } else {
          page = <Accesspage></Accesspage>;
        }

        break;
      case "edit-user":
      case "edit-doctor":
      case "edittvscreen":
      case "edit-service-group":
      case "edit-units":
      case "edit-work-stations":
      case "edit-departments":
      case "edit-services":
        if (showEdit) {
          page = <Add_User {...this.props} menuList={menuList} />;
        } else {
          page = <Accesspage></Accesspage>;
        }
        break;
      case "view-user":
      case "view-doctor":
      case "viewtvscreen":
      case "view-service-group":
      case "view-units":
      case "view-work-stations":
      case "view-departments":
      case "view-services":
        if (showView) {
          page = <User_Details {...this.props} menuList={menuList} />;
        } else {
          page = <Accesspage></Accesspage>;
        }
        break;
      case "add-role":
        if (showAdd) {
          page = <Add_Role {...this.props} menuList={menuList} />;
        } else {
          page = <Accesspage></Accesspage>;
        }

        break;
      case "view-role":
        if (showView) {
          page = <Add_Role {...this.props} menuList={menuList} />;
        } else {
          page = <Accesspage></Accesspage>;
        }
        break;
      case "edit-role":
        if (showEdit) {
          page = <Add_Role {...this.props} menuList={menuList} />;
        } else {
          page = <Accesspage></Accesspage>;
        }
        break;
      default:
        let submenu = null;
        page = <Accesspage></Accesspage>;
        break;
    }

    return page;
  }
  render() {
    return <div>{this.renderbodyLayer()}</div>;
  }
}

export default Settings;
